<template>
    <div class="overlay">
      <div v-if="!token" class="modal-create-token">
        <div class="modal-header">
          <span class="title">{{ __('NOVO TOKEN') }}</span>
          <button class="close-button" @click="$emit('close')">&#10005;</button>
        </div>
  
        <div class="modal-body">
          <div class="form-group">
            <label class="label">{{ __('Nome') }}</label>
            <input v-model="name" class="input" :placeholder="__('')" />
          </div>
        </div>
  
        <div class="modal-footer d-flex flex-column w-100 px-4 pb-4">
          <div class="w-100 d-flex justify-content-center mb-3">
            <button
              class="swal2-confirm salesflow-btn salesflow-btn-secondary"
              :disabled="isSaving || !name"
              type="button"
              @click="createToken"
            >
              {{ isSaving ? (__('Salvando') + '...') : __('Salvar') }}
            </button>
          </div>

            <button
                class="swal2-cancel btn swal2-btn-cancel-transparent swal2-btn-full-line"
                type="button"
                @click="$emit('close')"
            >
                {{ __('Cancelar') }}
            </button>
        </div>
      </div>
  
      <div v-else class="modal-token-created">
        <div class="modal-header">
          <span class="title">{{ __('NOVO TOKEN') }}</span>
          <button class="close-button" @click="$emit('close')">&#10005;</button>
        </div>
  
        <div class="modal-body">
            <div class="token-wrapper">
                <div class="token-label">
                <div class="label-text">
                    <p class="label-desc">{{ __('Aqui está seu novo token privado') }}</p>
                    <p class="label-desc">{{ __('Copie seu token privado e cole em um local seguro.') }}</p>
                    <p class="label-title">{{ __('Ele será exibido somente desta vez.') }}</p>
                </div>
                </div>

                <div class="token-display">
                <div class="token-box">
                    <input :value="token" readonly class="token-input" />
                    <Copy class="copy-icon" :size="18" @click.native="copyToken" />
                </div>
                </div>
            </div>
        </div>
  
        <div class="modal-footer">
            <button
                class="swal2-confirm salesflow-btn salesflow-btn-secondary"
                @click="$emit('close')"
                >
                {{ __('Concluir') }}
            </button>
        </div>
      </div>
    </div>
  </template>   
  
  <script>
  import Copy from './icon/Copy2.vue'
  import Swal from 'sweetalert2'
  
  export default {
    components: { Copy },
    data () {
      return {
        name: '',
        token: '',
        isSaving: false
      }
    },
    methods: {
      async createToken () {
        if (!this.name.trim()) return

        this.isSaving = true
        try {
          const response = await this.$http.post('/oauth/forwhats/personal-access-tokens', {
            name: this.name
          })
          this.token = response.body.accessToken || response.body.token || 'TOKEN_GERADO'
          this.$emit('created')
        } catch (err) {
          console.error('Erro ao criar token:', err)
        } finally {
          this.isSaving = false
        }
      },
      async copyToken () {
        await navigator.clipboard.writeText(this.token)
        Alert.success(this.__('Token copiado'))
      }
    }
  }
  </script>
  
  <style scoped>
  .overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Montserrat', sans-serif;
  }
  
  .modal-create-token {
    position: relative;
    width: 415px;
    min-height: 272px;
    background: #F5F5F5;
    box-shadow: -3px 4px 12px 3px rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    overflow: hidden;
  }
  
  .modal-create-token .modal-header,
  .modal-token-created .modal-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    gap: 86px;
    width: 100%;
    height: 50px;
    background: #886AF8;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
  
  .title {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    width: 85px;
    height: 18px;
    display: flex;
    align-items: flex-start;
    margin-left: 24px;
  }
  
  .close-button {
    background: none;
    border: none;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 24px;
  }
  
  .modal-body {
    flex-grow: 1;
    width: 100%;
    padding: 16px 24px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
    padding: 0;
    width: 100%;
    height: 100%;
    margin-bottom: 0px !important;
  }
  
  .label {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 8px;
    height: 18px;
    line-height: 150%;
    color: #000;
  }
  
  .input {
    width: 100%;
    height: 40px;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #CBD5E1;
    border-radius: 5px;
    font-size: 16px;
    box-sizing: border-box;
    color: #475569;
    font-family: 'Inter', sans-serif;
  }

  
  .modal-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 16px;
    width: 100%;
  }
  
  .save-wrapper {
    margin-top: 32px;
  }

  .cancel-wrapper {
    margin-top: 16px;
    margin-bottom: 24px;
  }

  .swal2-confirm.salesflow-btn {
    min-width: 116px;
    height: 50px;
    margin-top: 8px !important;
  }

  .swal2-cancel.swal2-btn-cancel-transparent.swal2-btn-full-line {
    width: 72px;
    height: 18px;
    text-decoration: underline;
    font-size: 12px;
    font-weight: 600;
    color: #71767D;
    background: transparent;
    border: none;
  }

  .swal2-cancel.swal2-btn-cancel-transparent.swal2-btn-full-line:hover {
    color: #7C3AED;
    cursor:pointer;
  }

  .modal-footer > .swal2-confirm {
    margin-bottom: 16px;
  }

  .modal-token-created {
    width: 491px;
    background: #F5F5F5;
    box-shadow: -3px 4px 12px 3px rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    padding: 0;
  }

  .modal-body {
    padding: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }


  .token-label {
    width: 100%;
    margin-bottom: 0;
  }

  .label-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0;
    gap: 4px;
    width: 313px;
    height: 82px;
    font-family: 'Montserrat', sans-serif;
  }

  .label-text .label-desc {
    font-size: 12px;
    font-weight: 500;
    line-height: 217%;
    margin: 0;
  }

  .label-text {
    font-size: 12px;
    font-weight: 600;
    line-height: 217%;
    margin: 0;
  }

  .label-title {
    font-size: 12px;
    font-weight: 600;
    line-height: 217%;
    margin: 0 0 8px 0;
  }

  .token-display {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .token-box {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px 12px;
    width: 443px;
    height: 52px;
    border: 1px solid #D1D1D1;
    border-radius: 8px;
    background: rgba(226, 232, 240, 0.4);
    z-index: 1;
  }

  .token-input {
    width: 100%;
    height: 18px;
    border: none;
    background: transparent;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #212529;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .modal-token-created .modal-footer {
    width: 100%;
    padding: 0 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  .save-button {
    width: 135px;
    height: 50px;
    background: #2CEBA9;
    border: 1px solid #2CEBA9;
    border-radius: 14px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .token-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .copy-icon {
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .swal2-cancel {
    padding: 0 !important;
    margin-left: 0 !important;
  }

  </style>
  